// One shell-only composition, three presentations (functions/
// assistantFlyWorkspace.js holds every value): the canvas bar's note, the
// return control over an open pane, and the section picker, mounted once at
// the shell root. No toolbar (Nika 2026-10-23: "open workspace tools is already
// in top menu so whats the point?"): "Add section" opens this picker from the
// composer's "+" menu (canvas CanvasPromptTextarea AttachMenu FlySectionRow).
export const AssistantFlyWorkspace = {
  presentation: 'status',
  display: 'contents',

  // "Section added" — said in the canvas's bar, where the page shows, and to a
  // screen reader (a live region, always mounted so the announcement lands).
  FlyWorkspaceStatus: {
    if: (el) => el.parent.presentation === 'status',
    tag: 'span',
    role: 'status',
    ariaLive: 'polite',
    fontSize: 'Z',
    color: 'caption',
    text: (el, s) => {
      const state = el.call('assistantFlyWorkspaceState', s.root) || {}
      return state.status === 'added' ? el.call('polyglot', 'shell.flyWorkspace.added') : ''
    }
  },

  FlyWorkspaceReturn: {
    if: (el) => el.parent.presentation === 'return',
    hide: (el, s) => !el.call('assistantFlyWorkspaceReturnShown', s.root),
    display: 'flex',
    flow: 'x wrap',
    alignItems: 'center',
    gap: 'Y',
    minWidth: '0',
    position: 'fixed',
    zIndex: '1340',
    bottom: 'calc(var(--slot-bottom) + var(--chip-row) + var(--spacing-Z))',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'max-content',
    maxWidth: 'calc(100% - var(--spacing-B))',
    padding: 'Y Z',
    theme: 'common-box',
    shadow: 'float',
    round: 'radiusControl',
    AppCapsuleBtnGhost: {
      text: '{{ shell.flyWorkspace.return | polyglot }}',
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
      disabled: (el, s) =>
        (el.call('assistantFlyWorkspaceState', s.root) || {}).status === 'returning',
      ariaBusy: (el, s) =>
        (el.call('assistantFlyWorkspaceState', s.root) || {}).status === 'returning',
      onClick: (e, el) => el.call('assistantFlyWorkspaceReturn')
    },
    FlyWorkspaceReturnError: {
      tag: 'span',
      role: 'alert',
      fontSize: 'Z',
      color: 'caption',
      text: (el, s) => {
        const state = el.call('assistantFlyWorkspaceState', s.root) || {}
        return state.status === 'failed' && !state.picker
          ? el.call('polyglot', el.call('assistantFlyWorkspaceErrorKey', state.error))
          : ''
      }
    }
  },

  AppDialog: {
    if: (el) => el.parent.presentation === 'picker',
    closeCall: 'assistantFlyWorkspaceClose',
    presentation: 'center',
    panelSize: 'md',
    initialFocus: 'field',
    position: 'fixed',
    zIndex: '2000',
    isOpen: (el, s) => {
      const open = !!(el.call('assistantFlyWorkspaceState', s.root) || {}).picker
      el.call('appDialogSync', open)
      return open
    },
    Panel: {
      AppDialogHead: {
        titleId: 'flyWorkspacePickerTitle',
        heading: 'shell.flyWorkspace.section',
        subtitle: 'shell.flyWorkspace.sectionHint'
      },
      AppDialogBody: {
        AppCombobox: {
          limit: 30,
          ariaLabel: (el) => el.call('polyglot', 'shell.flyWorkspace.search'),
          placeholder: 'shell.flyWorkspace.search',
          options: (el, s) =>
            (el.call('assistantFlyWorkspaceState', s.root) || {}).picker
              ? el.call('assistantFlyWorkspaceOptions', s.root)
              : [],
          select: 'assistantFlyWorkspaceSelect'
        },
        FlyWorkspaceEmpty: {
          tag: 'p',
          margin: '0',
          fontSize: 'Z1',
          color: 'caption',
          hide: (el) => !!el.parent.AppCombobox.options.length,
          text: '{{ shell.flyWorkspace.emptySections | polyglot }}'
        },
        FlyWorkspaceError: {
          tag: 'span',
          role: 'alert',
          fontSize: 'Z1',
          color: 'title',
          text: (el, s) => {
            const state = el.call('assistantFlyWorkspaceState', s.root) || {}
            return state.error
              ? el.call('polyglot', el.call('assistantFlyWorkspaceErrorKey', state.error))
              : ''
          }
        }
      }
    }
  }
}
